module.exports = __webpack_public_path__ + "img/Handshake.1ee9696a.png";